import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import LeaguesTabs from './LeaguesTabs';
import MyTeamInvites from './MyTeamInvites';
import MyUpcomingMatches from './MyUpcomingMatches';
import LeaguesProfileSection from '../players/LeaguesProfileSection';
import './Leagues.css';

/**
 * "Mina sidor" — the personal hub of the leagues section. Gathers the things a
 * logged-in player needs to act on in one place: pending team invitations,
 * their upcoming league fixtures, and the leagues/teams they belong to. Shown as
 * a tab alongside Ligor and Lag.
 *
 * @returns {JSX.Element} The personal leagues page.
 */
export default function MyLeagues() {
  const { t } = useTranslation();
  const { isLoggedIn, user } = useAuth();
  // Bump after accepting an invite so "Mina ligor & lag" reflects the new team.
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="league-page">
      <div className="league-page-header">
        <h1 className="league-page-title">{t('nav.leagues')}</h1>
      </div>
      <LeaguesTabs />

      {!isLoggedIn ? (
        <div className="league-empty">
          {t('leagues.loginToSee')}
        </div>
      ) : (
        <>
          <MyTeamInvites onChange={() => setRefreshKey((k) => k + 1)} />
          <MyUpcomingMatches />
          {user?.steam_id && (
            <LeaguesProfileSection key={refreshKey} steamid64={user.steam_id} />
          )}
        </>
      )}
    </div>
  );
}
